export enum BluetoothPermissionEnum {
    Advertising = 1
}
